export { DocSkeleton } from './DocSkeleton';
